export enum TftCondition {
  GreaterEqual = "GreaterEqual",
  Only = "Only"
}
